let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3qvUT")).then(() => parcelRequire('hBA7n'));